import { useCallback, useContext, useEffect, useState } from 'react'
import { getAnuncios } from '../services/home.services'
import { TenantsContext } from '../../../context/tenants.context'
import { Config } from '../../AbmLocalPage/types'

export interface IAnuncio {
  idNoticia: number
  idAnuncio: number
  idAnuncioTipo: number
  anuncianteNombre: string
  nombre: string
  url_imagen: string
  urlImagen: string
  urlImagenWide: string
  detalleTexto: string
  detalleImagenList: { url: string; cta: any }[]
  detalleLink: string
  orden: number
  data: any
  premium: boolean
}

export const useAnuncios = (codLocal: string) => {
  const [loading, setLoading] = useState<boolean>(true)
  const [bannerPremium, setBannerPremium] = useState<IAnuncio | null>(null)
  const [anuncios, setAnuncios] = useState<IAnuncio[]>()
  const { tenant } = useContext(TenantsContext)
  const idBannerConfig = tenant.config?.find((c: Config) => c.name === 'premium_anuncioVendedor')?.value

  const fetchData = useCallback(async () => {
    if (!codLocal || anuncios) return
    try {
      setLoading(true)
      const res = await getAnuncios(codLocal, tenant)
      setAnuncios(res.data.data)
      fetchBannerPremium()
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }, [tenant, codLocal, anuncios])

  useEffect(() => {
    fetchData()
  }, [codLocal])

  const fetchBannerPremium = useCallback(() => {
    if (anuncios && idBannerConfig) {
      const banner = anuncios.find((a: IAnuncio) => a.idAnuncio === parseInt(idBannerConfig))
      setBannerPremium(banner || null)
    }
  }, [anuncios, idBannerConfig])

  return { anuncios, bannerPremium, idBannerConfig, fetchData, fetchBannerPremium, loading }
}
